import Breadcrumbs from "theme/components/Breadcrumbs";
import CustomerServiceMenu from "theme/components/customerService/CustomerServiceMenu";
import Div from "theme/layouts/Div";
import PageWrapper from "theme/components/wrappers/PageWrapper";
import PropTypes from "prop-types";
import React from "react";
import ScalingGridWrapper from "theme/components/wrappers/ScalingGridWrapper";
import { above } from "core-web/utils/mediaqueries";
import colors from "theme/config/colors";
import postTemplates from "./templates";
import styled from "theme/libs/styled";
import { useTranslation } from "react-i18next";

const ContentSection = styled("section")`
    display: grid;
    gap: 64px;

    ${above.tabletLg} {
        gap: 48px;

        @supports (grid-template-columns: subgrid) {
            grid-template-columns: subgrid;
            height: max-content;

            > * {
                grid-column: span 6;
            }

            [data-is-fullwidth="true"] {
                grid-column: 1 / -1;
            }
        }
    }
`;

const StyledScalingGridWrapper = styled(ScalingGridWrapper)`
    ${above.tabletLg} {
        padding-top: 16px;
    }
`;

const CustomerService = ({ data }) => {
    const { t } = useTranslation();

    const { breadcrumbs, title, template, ...rest } = data;
    const PostTemplate = postTemplates[template];

    let allBreadcrumbs = [{ permalink: "/", title: t("breadcrumbs.home") }];
    if (breadcrumbs) {
        allBreadcrumbs = allBreadcrumbs.concat(breadcrumbs);
    }
    allBreadcrumbs.push({ permalink: null, title });

    return (
        <PageWrapper>
            <StyledScalingGridWrapper>
                <Div
                    as="aside"
                    gridColumn={["1 / -1", null, null, null, "1 / span 3"]}
                    borderRight={["none", null, null, null, `1px solid ${colors.black_10}`]}
                >
                    <Breadcrumbs breadcrumbs={allBreadcrumbs} />
                    <CustomerServiceMenu />
                </Div>

                <ContentSection
                    gridColumn={["1 / -1", null, null, null, "5 / -1"]}
                    mt={["64px", null, null, null, "80px"]}
                >
                    <PostTemplate {...rest} />
                </ContentSection>
            </StyledScalingGridWrapper>
        </PageWrapper>
    );
};

CustomerService.propTypes = {
    data: PropTypes.shape({
        ancestor_ids: PropTypes.arrayOf(PropTypes.number),
        breadcrumbs: PropTypes.array,
        hero_content: PropTypes.array,
        id: PropTypes.number,
        page_content: PropTypes.array,
        permalink: PropTypes.string,
        sibling_ids: PropTypes.arrayOf(PropTypes.number),
        sort_order: PropTypes.number,
        subpage_ids: PropTypes.arrayOf(PropTypes.number),
        template: PropTypes.string,
        title: PropTypes.string,
    }).isRequired,
};

export default CustomerService;
